import { render, staticRenderFns } from "./EngineerBreakTime.vue?vue&type=template&id=1b8534ae&"
import script from "./EngineerBreakTime.vue?vue&type=script&lang=js&"
export * from "./EngineerBreakTime.vue?vue&type=script&lang=js&"
import style0 from "./EngineerBreakTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip}, component.options.components || {})
